import Moment from 'moment';
import { extendMoment } from 'moment-range';

const moment = extendMoment(Moment);

const getMaxParticipants = (
  seatsLeft,
  initialValues,
  bookRelatedActivityForm,
  availableParticipantsData,
  newSelectedStartTime
) => {
  if (
    !initialValues ||
    !initialValues.startingDate ||
    !bookRelatedActivityForm.values.startingDate ||
    !availableParticipantsData
  ) {
    return seatsLeft;
  }

  const startingDate = moment(
    bookRelatedActivityForm.values.startingDate
  ).format('YYYY-MM-DD');

  if (
    moment(bookRelatedActivityForm.values.startingDate).isSame(
      initialValues.startingDate,
      'day'
    )
  ) {
    const activities = availableParticipantsData.activities;

    if (activities.length) {
      const availableParticipantsPerDate =
        activities[0].availableParticipantsPerDate || [];
      const selectedStartTime =
        newSelectedStartTime || bookRelatedActivityForm.values.startTime;
      const startTime = selectedStartTime
        ? moment(selectedStartTime.startTime, 'HH:mm').format('HH:mm:ss')
        : null;

      const existedDate = availableParticipantsPerDate.find(
        item =>
          item.date === startingDate &&
          (item.startTime === startTime || (!item.startTime && !startTime))
      );

      if (!!existedDate) {
        const numberOfBookedParticipants = initialValues.participants.reduce(
          (accumulator, participant) =>
            accumulator + (parseInt(participant['participants']) || 0),
          0
        );

        return parseInt(seatsLeft) + numberOfBookedParticipants;
      }
    }
  }

  return seatsLeft;
};

const getAvailableParticipantsForStartTime = (
  listOfStartTimeAndDuration,
  bookedData,
  bookForm,
  availableParticipantsData
) => {
  if (!bookedData || !bookedData.startTime) return listOfStartTimeAndDuration;

  return listOfStartTimeAndDuration.map(item => {
    if (item.id === bookedData.startTime.id) {
      const maxParticipants = getMaxParticipants(
        item.seatsLeft,
        bookedData,
        bookForm,
        availableParticipantsData,
        item
      );
      return {
        ...item,
        maxParticipants: maxParticipants,
        seatsLeft: parseInt(maxParticipants)
      };
    }

    return item;
  });
};

const getMaxParticipantsActivitySeveralDays = (
  availableParticipantsPerDate,
  startDate,
  endDate,
  bookedData
) => {
  let availableParticipants = null;

  availableParticipantsPerDate.forEach(item => {
    const itemDate = moment(item.date, 'YYYY-MM-DD');
    if (itemDate.isBetween(startDate, endDate, 'days', '[]')) {
      if (availableParticipants !== null) {
        if (availableParticipants > item.availableParticipants) {
          availableParticipants = item.availableParticipants;
        }
      } else {
        availableParticipants = item.availableParticipants;
      }
    }
  });

  if (bookedData && bookedData.multiDates) {
    const bookedRange = moment.range(
      bookedData.multiDates.startDate,
      bookedData.multiDates.endDate
    );

    const selectedRange = moment.range(
      moment(moment(startDate).format('DD/MM/YYYY'), 'DD/MM/YYYY'),
      moment(moment(endDate).format('DD/MM/YYYY'), 'DD/MM/YYYY')
    );

    const overlaps = selectedRange.overlaps(bookedRange, { adjacent: true });

    const bookedPlaces = bookedData.participants.reduce(
      (acc, obj) => acc + parseInt(obj.participants),
      0
    );

    if (overlaps) {
      if (!availableParticipants) availableParticipants = 0;
      return availableParticipants + bookedPlaces;
    }
  }

  return availableParticipants;
};

export {
  getMaxParticipants,
  getAvailableParticipantsForStartTime,
  getMaxParticipantsActivitySeveralDays
};
